import React from "react";
import IOrder from "../../../../models/IOrder";
import moment from "moment-timezone";
import styled from "styled-components";
import { Link } from "react-router-dom";
import "../DueDateCalendarDay/DueDateCalendarDay.scss";

type Props = {
    orders: IOrder[];
    day: moment.Moment;
    index: number;
};

export const DueDateCalendarDay = (props: Props) => {
    return (
        <DueDateCalendarDayDiv className={"DueDateCalendarDay " + (props.index % 2 === 0 ? "other-day" : "")}>
            <DueDateDayHeaderDiv>
                {props.day.format("ddd MM/DD")}{" "}
                {props.orders.length ? <CountCircle className={"bg-warning"}>{props.orders.length}</CountCircle> : null}
            </DueDateDayHeaderDiv>
            <DueDateOrderContainer>
                {props.orders.map((order: IOrder) => {
                    return (
                        <OrderDiv key={order.guid} className={order.is_expedited ? "bg-danger" : "bg-primary"}>
                            <Link to={`/orders/${order.guid}/entry`}>{order.name}</Link>
                        </OrderDiv>
                    );
                })}
            </DueDateOrderContainer>
        </DueDateCalendarDayDiv>
    );
};

const DueDateCalendarDayDiv = styled.div`
    display: block;
    width: 14.285%;
    height: 150px;
    max-height: 150px;
    border: 1px solid #000;
    flex-direction: column;
`;

const DueDateDayHeaderDiv = styled.div`
    font-weight: bold;
    border-bottom: 1px solid #000;
    min-height: 30px;
    height: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.7vw;
`;

const CountCircle = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
`;

const DueDateOrderContainer = styled.div`
    height: 116px;
    width: 100%;
    display: block;
    justify-content: center;
    flex-direction: column;
    overflow-y: auto;
    padding: 2px;
`;

const OrderDiv = styled.div`
    border-radius: 5px;
    margin-bottom: 5px;
    font-size: 0.8rem;
    color: #fff;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    line-height: 30px;
    font-weight: bold;
    cursor: pointer;

    a {
        color: #fff;
        cursor: pointer;
    }
`;
